import microverse from '../../assets/img/logos/microverse.png';
import accenture from '../../assets/img/logos/accenture.png';
import isma from '../../assets/img/logos/isma.png';
import cognizant from '../../assets/img/logos/cognizant.png';
import arc from '../../assets/img/logos/arc.png';

export default {
  education: [{
      title: 'Master of Computer science and Information Technology',
      description: '02/09/2015 - ongoing',
      image: isma
    },
    {
      title: 'Professional full stack web developer student',
      description: '08/02/2020 - Ongoing',
      image: microverse
    },
    {
      title: 'Bachelor of Computer science and Information Technology',
      description: '02/09/2015 - 26/06/2019',
      image: isma
    }
  ],
  work: [{
      title: 'Integration Platform services - DevOps',
      description: '16/05/2020 - 15/09/2020',
      image: cognizant
    },
    {
      title: 'Full-Stack web developer - Freelancer',
      description: '10/09/2019 - Ongoing',
      image: arc
    },
    {
      title: 'Javascript UI',
      description: '08/02/2019 - 20/08/2019',
      image: accenture
    },

  ]
};